import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Space,Tag,Progress,message,Checkbox,label,Input,Button ,Select,DatePicker,   } from 'antd';
import DatePickers from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import { UploadOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';

const { TextArea } = Input;
const { Option } = Select;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

const dateFormat = "MMMM d, yyyy h:mm aa";

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {			
			employee_list : [],
			task_manager_details : [],
			title : '',
			employee_id : '',
			description : '',
			date_time : new Date(),
			school_id : '',
			user_id : '',
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);	
		
			
		this.handleSubmit = this.handleSubmit.bind(this);	
		
		this.handleDateChange = this.handleDateChange.bind(this);	
		
		this.handleChange = this.handleChange.bind(this);
	}
	
	

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			this.setState({ 
				user_id : storedArray['data'][0]['user_id'],
				school_id : storedArray['data'][0]['school_id'] ,
				id : this.props.match.params.id ,
				}
			);
		}		
		var date = new Date();
		var  currentDate = date.getFullYear() + "-" + (date.getMonth()) + "-" + date.getDate();
		this.setState({ currentDate : currentDate });
		
		this.checkData();
		
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id,id : this.props.match.params.id}
			getData('erp/view_staff',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							employee_list: result['data'],
						});
					}else{
						this.setState({
							employee_list: [],
						});
					}
				}
			});
			getData('credzoTaskManager/task_manager_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						var date_time = result['data'][0]['date_time'];
						//date_time  = moment.utc(date_time).format();
						const d1 = new Date(date_time);
						d1.toString();
						
						this.setState({
							task_manager_details: result['data'],
							employee_id: result['data'][0]['employee_id'],
							title: result['data'][0]['title'],
							description: result['data'][0]['description'],
							date_time : d1,
						});
					}else{
						this.setState({
							task_manager_details: [],
						});
					}
				}
			});
		}
	}
  
  
	
	handleChange(value) {
	  this.setState({ employee_id: value });
	  document.getElementsByClassName('ant-select-selection')[0].classList.remove("error_focus");
	}
	
	handleDateChange = date => {
		this.setState({
			date_time: date
		});
	};
	

	
	
	
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
		if(e.target.name){
			document.getElementsByName(e.target.name)[0].classList.remove("error_focus");
		}
	 };
	
	handleSubmit=(e)=>{
		if(localStorage.getItem('schoolData')){
			this.setState({ loading: true });
			var app = {
				user_id : this.state.user_id,
				school_id : this.state.school_id,
				title : this.state.title,
				employee_id : this.state.employee_id,
				description : this.state.description,
				date_time : this.state.date_time,
				id : this.props.match.params.id,
			}
			getData('credzoTaskManager/update_task_manager',app).then((result) => {
				if(result.status==400){
					message.config({ top: 150});
					message.error(result.error_msg,2);
					if(result.error_name=='' && result.error_key!=''){
						document.getElementsByClassName('ant-select-selection')[result.error_key].classList.add("error_focus");					
					}
					else{					
						if(result.error_name!=''){
							document.getElementsByName(result.error_name)[0].classList.add("error_focus");
						}					
					}
					this.setState({ loading: false });
				}
				if(result.status==200){
					message.config({ top: 150});
					message.success('Task Updated',2);
					this.setState({ loading: false });
					window.location.href = '/task-manager/ongoing';
				}
			});
		}
		else{
			message.error('Please Login',2);	
		}
	}
  
	
  
  

	render()

	{
	
		const { size } = this.state;
		
		
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 <div class="col col-md-12  ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col col-md-12  header-title mt-20 mh-40 iq-card">
                     <div class="col s12 m4  l4 pt-10 pb-15">
                       <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Edit Task</span></h5>
                     </div>
                     <div class="col s12 m8 l8 right-align-md pt-15 pb-15">
                        <ol class="breadcrumbs mb-0">
                          <li class="breadcrumb-item"><a href="/">Home</a>
                           </li> 
						   <li class="breadcrumb-item"><a href="/">Task Manager</a>
                           </li>
                           <li class="breadcrumb-item active">Edit Task
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
		</div>	
            
            <div class="col col-md-12  ex-padd">
			
			
			{this.state.task_manager_details.map((list) => (
			<div class="container view-Profile child-profile">
			   <div class="col col-md-12  mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
					<div class="children mb-20  iq-card2 flow-root">
                     
						<div class="d-flex">
						  
						  <div class="col col-md-12 s12 no-padd">
								<div class="col m6 s12  mb-10">
									<label>Title</label>
									<input type="text" name="title" onChange={this.handleSizeChange} defaultValue={list.title} required/>
								</div>
								<div class="col m6 s12  mb-10 datetime_picker">
									<label>Date & Time</label>
									<DatePickers
										selected={this.state.date_time}
										onChange={this.handleDateChange}
										minDate={new Date()}
										showTimeSelect
										timeIntervals={15}
										timeCaption="Time"
										dateFormat="MMMM d, yyyy h:mm aa"
									/>
								</div>	
								<div class="col m6 s12  mb-10 dis-input">
									<label>Employee</label>
									<Select 
									  mode="multiple"
									  allowClear
									  style={{ width: '100%' }}
									  placeholder="Please select"
									  onChange={this.handleChange}
									  optionLabelProp="label"
									  name="employee_id"
									  defaultValue={list.employee_id}
									>
									{this.state.employee_list.map((list) => (
										<Option value={list.id} label={list.name}>
										  <div className="demo-option-label-item">
											{list.name}
										  </div>
										</Option>
									))}
									</Select>
								</div>
								<div class="col m6 s12  mb-10">
									<label>Description</label>
									<TextArea rows={4} style={{'width' : '100%'}} name="description" defaultValue={list.description} onChange={this.handleSizeChange}/>
								</div>
								
								
						  </div>
						 
						</div>
							
					</div> 
					
					
					<div class="col col-md-12 s12 meal bt pt-10 mb-10 center">
						 <Button className="snd-btn"  onClick={this.handleSubmit} loading={this.state.loading}>Submit</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
			))}
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
